import styled, { css } from "styled-components/macro";
import { Button } from "@mui/material";
import { FONT_SIZE_EXTRA_SMALL } from "constants/constants";
import {
  useFocusRange,
  useGetPageFromPath,
} from "utils/customHooks/genericHooks";
import {
  ONE_DAY_OF_MS,
  TRENDS_RANGE_MAX_RECOMMENDED_MACHINES_TO_LOAD_TIMELINE,
} from "utils/timeUtils";
import { blueButton, darkModeTextColor } from "constants/colors";
import { useIsDarkMode } from "store/atoms";

const ShowTimelineButtonStyles = styled.div<{ $isDarkMode: boolean }>`
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 6em auto;
  .revealTimelineButton {
    margin: 0 auto 1em;
    text-transform: none;
    color: ${blueButton};
    border: 1px solid ${blueButton};
    border-radius: 4px;
    padding: 5px 30px;
  }
  .note {
    font-size: ${FONT_SIZE_EXTRA_SMALL}px;
    text-align: center;
    line-height: 1.5em;
    .bold {
      font-weight: bold;
    }
  }
  ${({ $isDarkMode }) =>
    $isDarkMode
      ? css`
          color: ${darkModeTextColor};
        `
      : ""}
`;

export default function ShowTimelineButton({
  onClick,
  showNote,
}: {
  onClick: () => void;
  showNote: boolean;
}) {
  const focusRange = useFocusRange();
  const duration = focusRange ? focusRange.lt - focusRange.ge : 0;
  const maxRecommendedMachinesToLoadTimeline =
    duration > ONE_DAY_OF_MS
      ? TRENDS_RANGE_MAX_RECOMMENDED_MACHINES_TO_LOAD_TIMELINE.day
      : duration > 7 * ONE_DAY_OF_MS
        ? TRENDS_RANGE_MAX_RECOMMENDED_MACHINES_TO_LOAD_TIMELINE.week
        : duration > 30 * ONE_DAY_OF_MS
          ? TRENDS_RANGE_MAX_RECOMMENDED_MACHINES_TO_LOAD_TIMELINE.month
          : TRENDS_RANGE_MAX_RECOMMENDED_MACHINES_TO_LOAD_TIMELINE.ninetyDays;
  const { isTrendsPage } = useGetPageFromPath();

  const [isDarkMode] = useIsDarkMode();
  return (
    <ShowTimelineButtonStyles
      className="doNotPrint"
      data-component-name={"Show Timeline Button"}
      $isDarkMode={isDarkMode}
    >
      <Button
        variant="outlined"
        className="revealTimelineButton"
        onClick={onClick}
      >
        Load Timeline
      </Button>
      {showNote && (
        <div className="note">
          <div className="bold">NOTE:</div>
          <div>MAY SIGNIFICANTLY SLOW DOWN THE PAGE.</div>
          {isTrendsPage &&
            `NOT CURRENTLY ADVISED FOR VIEWING MORE THAN ${maxRecommendedMachinesToLoadTimeline} PROCESSES.`}
        </div>
      )}
    </ShowTimelineButtonStyles>
  );
}
